import { Headline2 } from '../../../Headline2'

import * as styles from './DocFlowSendingWidgetContent.module.css'

function DocFlowSendingWidgetContent({
  Title = Headline2,
  children,
  className = styles.DocFlowSendingWidgetContent,
  title,
}) {
  return (
    <div className={className}>
      {Title ? <Title className={styles.header}>{title}</Title> : null}

      {children}
    </div>
  )
}

export default DocFlowSendingWidgetContent
